// @ts-nocheck
import imgMikseFriture from "../assets/images/rifat/pjata-1.jpeg";
import imgPeskatrice from "../assets/images/rifat/peskatrice.jpg";
import imgAntipastaPlatter from "../assets/images/rifat/pjata-9.jpeg";
import imgKrudo from "../assets/images/rifat/mikse-krudo.jpg";
import imgMikseZgare from "../assets/images/rifat/menu-item-6.jpg";
import imgTavaTryeza from "../assets/images/rifat/pjata-3.jpeg";

// Photographed at the restaurant, August 2026 - one plate per dish.
import dshAntipasteFtohte from "../assets/images/rifat/dishes/antipaste-deti-e-ftohte.jpg";
import dshBarbun from "../assets/images/rifat/dishes/barbun.jpg";
import dshBrusketa from "../assets/images/rifat/dishes/brusketa-domate.jpg";
import dshKallamare from "../assets/images/rifat/dishes/kallamare-friteze.jpg";
import dshKallamareZgare from "../assets/images/rifat/dishes/Kallamare-Zgare.jpeg";
import dshKallamareSalce from "../assets/images/rifat/dishes/Kallamar-Me-Salce.jpeg";
import dshKarkalecDyte from "../assets/images/rifat/dishes/karkalec-bregu-i-dyte.jpg";
import dshKoce from "../assets/images/rifat/dishes/koce.jpg";
import dshKoceDeti from "../assets/images/rifat/dishes/koce-deti.jpg";
import dshLevrek from "../assets/images/rifat/dishes/levrek.jpg";
import dshLinguiniDeti from "../assets/images/rifat/dishes/linguini-fruta-deti.jpg";
import dshLinguiniKungull from "../assets/images/rifat/dishes/linguini-karkaleca-kungull.jpg";
import dshLinguinSkampiKarkalec from "../assets/images/rifat/dishes/LInguini-Skampi-Karkalec.jpeg";
import dshMidhje from "../assets/images/rifat/dishes/midhje-sote.jpg";
import dshMikseFriture from "../assets/images/rifat/dishes/mikse-friture.jpg";
import dshPatate from "../assets/images/rifat/dishes/patate-friteze.jpg";
import dshPeneGjalp from "../assets/images/rifat/dishes/pene-me-gjalp.jpg";
import dshRisotoSkampi from "../assets/images/rifat/dishes/risoto-skampi-karkaleca.jpg";
import dshSallateFrutaDeti from "../assets/images/rifat/dishes/Sallate-Fruta-Deti.jpeg";
import dshSallateAcuge from "../assets/images/rifat/dishes/sallate-acuge.jpg";
import dshSallateMikse from "../assets/images/rifat/dishes/sallate-greke.jpg";
import dshSallateJeshile from "../assets/images/rifat/dishes/sallate-jeshile.jpg";
import dshSallateGreke from "../assets/images/rifat/dishes/sallate-mikse.jpg";
import dshSallateOktapodi from "../assets/images/rifat/dishes/sallate-oktapodi.jpg";
import dshSallateRukola from "../assets/images/rifat/dishes/sallate-rukola.jpg";
import dshSkampiZgare from "../assets/images/rifat/dishes/skampi-zgare.jpg";
import dshTaveDetiPikante from "../assets/images/rifat/dishes/tave-fruta-deti-pikante.jpg";
import dshTaveKarkaleci from "../assets/images/rifat/dishes/tave-karkaleci-me-pana.jpg";
import dshTunaSteak from "../assets/images/rifat/dishes/Fileto-Toni-Zgare.jpeg";
import dshFishSoup from "../assets/images/rifat/dishes/Supe-Peshku.jpeg";
import dshFishSoupVegetable from "../assets/images/rifat/dishes/Supe-Peshku-Perime.jpeg";
import dshGjuze from "../assets/images/rifat/dishes/Gjuze-Friture-Zgare.jpeg";
import dshTaveOktapodiPikant from "../assets/images/rifat/dishes/Tave-Oktapodi-Pikant.jpeg";
import dshOstrige from "../assets/images/rifat/dishes/ostrige.jpg";
import dshArragoste from "../assets/images/rifat/dishes/arragosta.jpg";
import dshOktapodZgare from "../assets/images/rifat/dishes/oktapod-zgare.jpg";
import dshKarkalecBreguPomodorini from "../assets/images/rifat/dishes/Karkalec-Bregu-Pomodorini.jpeg";
import dshKarkalecBreguMarinuar from "../assets/images/rifat/dishes/karkalec-bregu-i-marinuar.jpg";
import dshMerluc from "../assets/images/rifat/dishes/merluc-zgare.jpg";
import dshLeverkDeti from "../assets/images/rifat/dishes/levrek-deti.jpg";
import dshLeverkFurre from "../assets/images/rifat/dishes/levrek-furre-me-perime.jpg";
import dshSkampiMarinuar from "../assets/images/rifat/dishes/skampi-i-marinuar.jpg";
import dshOrizMeGjalp from "../assets/images/rifat/dishes/oriz-me-gjalp.jpg";
import dshPenePomodorini from "../assets/images/rifat/dishes/pene-pomodorini.jpg";
import dshSallateUlliri from "../assets/images/rifat/dishes/sallare-ulliri.jpg";
import dshDjathBardhe from "../assets/images/rifat/dishes/djath-i-bardhe.jpg";
import dshKackavall from "../assets/images/rifat/dishes/djathe-kackavall-zgare.jpg";
import rizotoFrutaDeti from "../assets/images/rifat/dishes/RizotoFrutaDeti.jpeg";
import rizotoKungullKarkalec from "../assets/images/rifat/dishes/RizotoKungullKarkalec.jpeg";
import dental from "../assets/images/rifat/dishes/dental.jpg";
import dentalFurre from "../assets/images/rifat/dishes/peshk-dental-ne-furre.jpg";
import kovac from "../assets/images/rifat/dishes/peshku-kovac.jpg";
import sepjeFriture from "../assets/images/rifat/dishes/sepje-friture.jpg";
import peskatriceFuure from "../assets/images/rifat/dishes/peskatice-ne-furre.jpg";



import stWhiteWine from "../assets/images/stock/white-wine.jpg";
import stRedWine from "../assets/images/stock/red-wine.jpg";
import vongole from "../assets/images/stock/clams.jpg";

/**
 * Menu - Hotel-Restorant Rifat Peshkatari.
 *
 * Transcribed from the printed menu in the restaurant, photographed August 2026.
 * That supersedes the 2024 PDF on the website, which is now out of date on most
 * prices. Where a price carried a handwritten sticker over the printed one, the
 * sticker is what is here.
 *
 * Names and prices are exactly as printed - nothing invented. Dishes the printed menu
 * gives no description for simply have none here.
 *
 * The two wine lists were photographed too and check out line for line against this
 * file - the 2024 prices had not moved. The one exception: the half-bottle Riesling is
 * printed "Resling Hugel 0.375" and is spelled correctly here.
 *
 * The menu itself is loaded from the server (`menuSource` in src/config/business.js), which
 * holds a copy of this file. This one is the backup bundled with the build: guests see it
 * whenever the server fails or is slow. Keep it - its shape matches what
 * `GET /api/menu-item/business/:id` returns.
 *
 * Category:
 *   id            number  unique, referenced by menuItems.menuCategoryId
 *   categoryName  string  also the translation key: categories.<categoryName>
 *   imageUrl      string  empty -> the icon placeholder is rendered instead
 *   icon          string  emoji used by the placeholder
 *   note          string  optional line shown under the category tabs
 *
 * Menu item:
 *   id, name (as printed, Albanian), description, price, priceUnit, imageUrl, icon,
 *   menuCategoryId, itemTranslation { englishName, italianName, ... }
 *   Languages missing from itemTranslation fall back to the printed Albanian name.
 */

const menu = [
    {
        id: 1,
        categoryName: "Antipasta",
        imageUrl: imgAntipastaPlatter,
        icon: "🥗",
        menuItems: [
            {
                id: 101,
                name: "Brusketa Domate",
                price: 250,
                priceUnit: "",
                imageUrl: dshBrusketa,
                icon: "🍅",
                menuCategoryId: 1,
                itemTranslation: { englishName: "Tomato Bruschetta", italianName: "Bruschetta al Pomodoro", germanName: "Tomaten-Bruschetta", spanishName: "Bruschetta de Tomate", polishName: "Bruschetta z Pomidorami", ukrainianName: "Брускета з помідорами" },
            },
            {
                id: 102,
                name: "Antipastë deti e Ftohtë",
                price: 1000,
                priceUnit: "",
                imageUrl: dshAntipasteFtohte,
                icon: "🦐",
                menuCategoryId: 1,
                itemTranslation: { englishName: "Cold Seafood Platter", italianName: "Antipasto di Mare Freddo", germanName: "Kalte Meeresfrüchteplatte", spanishName: "Entrante Frío de Marisco", polishName: "Zimna Płyta z Owoców Morza", ukrainianName: "Холодне асорті з морепродуктів" },
            },
            {
                id: 103,
                name: "Sallatë me Fruta Deti",
                price: 650,
                priceUnit: "",
                imageUrl: dshSallateFrutaDeti,
                icon: "🦑",
                menuCategoryId: 1,
                itemTranslation: { englishName: "Seafood Salad", italianName: "Insalata di Frutti di Mare", germanName: "Meeresfrüchtesalat", spanishName: "Ensalada de Mariscos", polishName: "Sałatka z Owoców Morza", ukrainianName: "Салат з морепродуктів" },
            },
            {
                id: 104,
                name: "Sallatë Oktapodi",
                price: 900,
                priceUnit: "",
                imageUrl: dshSallateOktapodi,
                icon: "🐙",
                menuCategoryId: 1,
                itemTranslation: { englishName: "Octopus Salad", italianName: "Insalata di Polpo", germanName: "Oktopussalat", spanishName: "Ensalada de Pulpo", polishName: "Sałatka z Ośmiornicy", ukrainianName: "Салат з восьминога" },
            },
            {
                id: 105,
                name: "Sallatë Acuge",
                price: 400,
                priceUnit: "",
                imageUrl: dshSallateAcuge,
                icon: "🐟",
                menuCategoryId: 1,
                itemTranslation: { englishName: "Anchovy Salad", italianName: "Insalata di Acciughe", germanName: "Sardellensalat", spanishName: "Ensalada de Anchoas", polishName: "Sałatka z Anchois", ukrainianName: "Салат з анчоусів" },
            },
            {
                id: 107,
                name: "Karkalec Bregu i Marinuar",
                price: 1500,
                priceUnit: "",
                imageUrl: dshKarkalecBreguMarinuar,
                icon: "🍤",
                menuCategoryId: 1,
                itemTranslation: { englishName: "Marinated Coastal Prawns", italianName: "Gamberi di Costa Marinati", germanName: "Marinierte Küstengarnelen", spanishName: "Gambas de Costa Marinadas", polishName: "Marynowane Krewetki Przybrzeżne", ukrainianName: "Мариновані прибережні креветки" },
            },
            {
                id: 108,
                name: "Skampi i Marinuar",
                price: 1500,
                priceUnit: "",
                imageUrl: dshSkampiMarinuar,
                icon: "🦐",
                menuCategoryId: 1,
                itemTranslation: { englishName: "Marinated Scampi", italianName: "Scampi Marinati", germanName: "Marinierte Scampi", spanishName: "Cigalas Marinadas", polishName: "Marynowane Skampi", ukrainianName: "Мариновані скампі" },
            },
            {
                id: 109,
                name: "Sallatë Jeshile",
                price: 250,
                priceUnit: "",
                imageUrl: dshSallateJeshile,
                icon: "🥬",
                menuCategoryId: 1,
                itemTranslation: { englishName: "Green Salad", italianName: "Insalata Verde", germanName: "Grüner Salat", spanishName: "Ensalada Verde", polishName: "Zielona Sałata", ukrainianName: "Зелений салат" },
            },
            {
                id: 110,
                name: "Sallatë Rukola",
                price: 400,
                priceUnit: "",
                imageUrl: dshSallateRukola,
                icon: "🥬",
                menuCategoryId: 1,
                itemTranslation: { englishName: "Rocket Salad", italianName: "Insalata di Rucola", germanName: "Rucola-Salat", spanishName: "Ensalada de Rúcula", polishName: "Sałatka z Rukoli", ukrainianName: "Салат з рукколи" },
            },
            {
                id: 111,
                name: "Sallatë Greke",
                price: 350,
                priceUnit: "",
                imageUrl: dshSallateGreke,
                icon: "🥗",
                menuCategoryId: 1,
                itemTranslation: { englishName: "Greek Salad", italianName: "Insalata Greca", germanName: "Griechischer Salat", spanishName: "Ensalada Griega", polishName: "Sałatka Grecka", ukrainianName: "Грецький салат" },
            },
            {
                id: 112,
                name: "Sallatë Mikse",
                price: 300,
                priceUnit: "",
                imageUrl: dshSallateMikse,
                icon: "🥗",
                menuCategoryId: 1,
                itemTranslation: { englishName: "Mixed Salad", italianName: "Insalata Mista", germanName: "Gemischter Salat", spanishName: "Ensalada Mixta", polishName: "Sałatka Mieszana", ukrainianName: "Мішаний салат" },
            },
            {
                id: 113,
                name: "Sallatë Ulliri",
                price: 200,
                priceUnit: "",
                imageUrl: dshSallateUlliri,
                icon: "🫒",
                menuCategoryId: 1,
                itemTranslation: { englishName: "Olive Salad", italianName: "Insalata di Olive", germanName: "Olivensalat", spanishName: "Ensalada de Aceitunas", polishName: "Sałatka z Oliwek", ukrainianName: "Салат з оливок" },
            },
            {
                id: 114,
                name: "Djathë i Bardhë",
                price: 200,
                priceUnit: "",
                imageUrl: dshDjathBardhe,
                icon: "🧀",
                menuCategoryId: 1,
                itemTranslation: { englishName: "White Cheese", italianName: "Formaggio Bianco", germanName: "Weißkäse", spanishName: "Queso Blanco", polishName: "Biały Ser", ukrainianName: "Білий сир" },
            },
            {
                id: 115,
                name: "Djathë Kaçkavall Zgarë",
                price: 250,
                priceUnit: "",
                imageUrl: dshKackavall,
                icon: "🧀",
                menuCategoryId: 1,
                itemTranslation: { englishName: "Grilled Kashkaval Cheese", italianName: "Caciocavallo alla Griglia", germanName: "Gegrillter Kaschkaval", spanishName: "Queso Kashkaval a la Parrilla", polishName: "Grillowany Ser Kaszkawał", ukrainianName: "Сир кашкавал на грилі" },
            },
            {
                id: 116,
                name: "Djathë Grana",
                price: 500,
                priceUnit: "",
                imageUrl: "",
                icon: "🧀",
                menuCategoryId: 1,
                itemTranslation: { englishName: "Grana Cheese", italianName: "Grana", germanName: "Grana-Käse", spanishName: "Queso Grana", polishName: "Ser Grana", ukrainianName: "Сир Грана" },
            },
            {
                id: 117,
                name: "Patate Friteze",
                price: 200,
                priceUnit: "",
                imageUrl: dshPatate,
                icon: "🍟",
                menuCategoryId: 1,
                itemTranslation: { englishName: "French Fries", italianName: "Patatine Fritte", germanName: "Pommes frites", spanishName: "Patatas Fritas", polishName: "Frytki", ukrainianName: "Картопля фрі" },
            },
            {
                id: 118,
                name: "Midhje Sote",
                price: 600,
                priceUnit: "",
                imageUrl: dshMidhje,
                icon: "🫕",
                menuCategoryId: 1,
                itemTranslation: { englishName: "Sautéed Mussels", italianName: "Cozze Saltate", germanName: "Sautierte Miesmuscheln", spanishName: "Mejillones Salteados", polishName: "Małże Sauté", ukrainianName: "Мідії соте" },
            },
            {
                id: 119,
                name: "Ostrike",
                price: 2000,
                priceUnit: "për kg",
                imageUrl: dshOstrige,
                icon: "🦪",
                menuCategoryId: 1,
                itemTranslation: { englishName: "Oysters", italianName: "Ostriche", germanName: "Austern", spanishName: "Ostras", polishName: "Ostrygi", ukrainianName: "Устриці" },
            },
            {
                id: 120,
                name: "Vongole",
                price: 2000,
                priceUnit: "për kg",
                imageUrl: vongole, isReferenceImage: true,
                icon: "🐚",
                menuCategoryId: 1,
                itemTranslation: { englishName: "Clams", italianName: "Vongole", germanName: "Venusmuscheln", spanishName: "Almejas", polishName: "Małże Vongole", ukrainianName: "Молюски вонголе" },
            },
        ],
    },
    {
        id: 2,
        categoryName: "Pjata e Parë",
        imageUrl: "",
        icon: "🍝",
        menuItems: [
            {
                id: 201,
                name: "Supë Peshku",
                price: 250,
                priceUnit: "",
                imageUrl: dshFishSoup,
                icon: "🥣",
                menuCategoryId: 2,
                itemTranslation: { englishName: "Fish Soup", italianName: "Zuppa di Pesce", germanName: "Fischsuppe", spanishName: "Sopa de Pescado", polishName: "Zupa Rybna", ukrainianName: "Рибний суп" },
            },
            {
                id: 211,
                name: "Supë Peshku me Perime",
                price: 400,
                priceUnit: "",
                imageUrl: dshFishSoupVegetable,
                icon: "🥣",
                menuCategoryId: 2,
                itemTranslation: { englishName: "Fish Soup with Vegetables", italianName: "Zuppa di Pesce con Verdure", germanName: "Fischsuppe mit Gemüse", spanishName: "Sopa de Pescado con Verduras", polishName: "Zupa Rybna z Warzywami", ukrainianName: "Рибний суп з овочами" },
            },
            {
                id: 202,
                name: "Pene me Pomodorini",
                price: 350,
                priceUnit: "",
                imageUrl: dshPenePomodorini,
                icon: "🍝",
                menuCategoryId: 2,
                itemTranslation: { englishName: "Penne with Cherry Tomatoes", italianName: "Penne ai Pomodorini", germanName: "Penne mit Kirschtomaten", spanishName: "Penne con Tomates Cherry", polishName: "Penne z Pomidorkami Koktajlowymi", ukrainianName: "Пенне з помідорами чері" },
            },
            {
                id: 203,
                name: "Pene me Gjalp",
                price: 300,
                priceUnit: "",
                imageUrl: dshPeneGjalp,
                icon: "🍝",
                menuCategoryId: 2,
                itemTranslation: { englishName: "Penne with Butter", italianName: "Penne al Burro", germanName: "Penne mit Butter", spanishName: "Penne con Mantequilla", polishName: "Penne z Masłem", ukrainianName: "Пенне з маслом" },
            },
            {
                id: 204,
                name: "Linguini Fruta Deti",
                price: 650,
                priceUnit: "",
                imageUrl: dshLinguiniDeti,
                icon: "🍝",
                menuCategoryId: 2,
                itemTranslation: { englishName: "Seafood Linguine", italianName: "Linguine ai Frutti di Mare", germanName: "Linguine mit Meeresfrüchten", spanishName: "Linguine con Mariscos", polishName: "Linguine z Owocami Morza", ukrainianName: "Лінгвіні з морепродуктами" },
            },
            {
                id: 205,
                name: "Linguini Karkaleca & Kungull",
                price: 700,
                priceUnit: "",
                imageUrl: dshLinguiniKungull,
                icon: "🍝",
                menuCategoryId: 2,
                itemTranslation: { englishName: "Linguine with Prawns & Zucchini", italianName: "Linguine Gamberi e Zucchine", germanName: "Linguine mit Garnelen und Zucchini", spanishName: "Linguine con Gambas y Calabacín", polishName: "Linguine z Krewetkami i Cukinią", ukrainianName: "Лінгвіні з креветками та кабачком" },
            },
            {
                id: 206,
                name: "Linguini Skampi & Karkaleca",
                price: 1200,
                priceUnit: "",
                imageUrl: dshLinguinSkampiKarkalec,
                icon: "🍝",
                menuCategoryId: 2,
                itemTranslation: { englishName: "Linguine with Scampi & Prawns", italianName: "Linguine Scampi e Gamberi", germanName: "Linguine mit Scampi und Garnelen", spanishName: "Linguine con Cigalas y Gambas", polishName: "Linguine ze Skampi i Krewetkami", ukrainianName: "Лінгвіні зі скампі та креветками" },
            },
            {
                id: 207,
                name: "Oriz me Gjalp",
                price: 300,
                priceUnit: "",
                imageUrl: dshOrizMeGjalp,
                icon: "🍚",
                menuCategoryId: 2,
                itemTranslation: { englishName: "Buttered Rice", italianName: "Riso al Burro", germanName: "Butterreis", spanishName: "Arroz con Mantequilla", polishName: "Ryż z Masłem", ukrainianName: "Рис з маслом" },
            },
            {
                id: 208,
                name: "Risoto Fruta Deti",
                price: 650,
                priceUnit: "",
                imageUrl: rizotoFrutaDeti,
                icon: "🍚",
                menuCategoryId: 2,
                itemTranslation: { englishName: "Seafood Risotto", italianName: "Risotto ai Frutti di Mare", germanName: "Meeresfrüchte-Risotto", spanishName: "Risotto de Mariscos", polishName: "Risotto z Owocami Morza", ukrainianName: "Різото з морепродуктами" },
            },
            {
                id: 209,
                name: "Risoto Karkaleca & Kungull",
                price: 700,
                priceUnit: "",
                imageUrl: rizotoKungullKarkalec,
                icon: "🍚",
                menuCategoryId: 2,
                itemTranslation: { englishName: "Risotto with Prawns & Zucchini", italianName: "Risotto Gamberi e Zucchine", germanName: "Risotto mit Garnelen und Zucchini", spanishName: "Risotto con Gambas y Calabacín", polishName: "Risotto z Krewetkami i Cukinią", ukrainianName: "Різото з креветками та кабачком" },
            },
            {
                id: 210,
                name: "Risoto Skampi & Karkaleca",
                price: 1200,
                priceUnit: "",
                imageUrl: dshRisotoSkampi,
                icon: "🍚",
                menuCategoryId: 2,
                itemTranslation: { englishName: "Risotto with Scampi & Prawns", italianName: "Risotto Scampi e Gamberi", germanName: "Risotto mit Scampi und Garnelen", spanishName: "Risotto con Cigalas y Gambas", polishName: "Risotto ze Skampi i Krewetkami", ukrainianName: "Різото зі скампі та креветками" },
            },
        ],
    },
    {
        id: 3,
        categoryName: "Fruta Deti",
        imageUrl: imgKrudo,
        icon: "🦐",
        note: "Peshk i freskët nga barkat pronë e lokalit",
        menuItems: [
            {
                id: 303,
                name: "Karkalec Bregu i Dytë (Zgare/Friteze/Vezë)",
                price: 1200,
                priceUnit: "",
                imageUrl: "",
                icon: "🍤",
                menuCategoryId: 3,
                itemTranslation: { englishName: "Coastal Prawns, Second Size (Grilled/Fried/with Egg)", italianName: "Gamberi di Costa, Seconda Misura", germanName: "Küstengarnelen, zweite Größe (Grill/Frittiert/mit Ei)", spanishName: "Gambas de Costa, Segunda (Parrilla/Fritas/con Huevo)", polishName: "Krewetki Przybrzeżne, Drugi Rozmiar", ukrainianName: "Прибережні креветки, другий розмір" },
            },
            {
                id: 304,
                name: "Karkalec Bregu (Zgare/Friteze/Vezë)",
                price: 1500,
                priceUnit: "",
                imageUrl: dshKarkalecDyte,
                icon: "🍤",
                menuCategoryId: 3,
                itemTranslation: { englishName: "Coastal Prawns (Grilled/Fried/with Egg)", italianName: "Gamberi di Costa (Griglia/Fritti/Uovo)", germanName: "Küstengarnelen (Grill/Frittiert/mit Ei)", spanishName: "Gambas de Costa (Parrilla/Fritas/con Huevo)", polishName: "Krewetki Przybrzeżne (Grill/Smażone/z Jajkiem)", ukrainianName: "Прибережні креветки (гриль/фрі/з яйцем)" },
            },
            {
                id: 305,
                name: "Karkalec Bregu Pomodorini",
                price: 1600,
                priceUnit: "",
                imageUrl: dshKarkalecBreguPomodorini,
                icon: "🍤",
                menuCategoryId: 3,
                itemTranslation: { englishName: "Coastal Prawns with Cherry Tomatoes", italianName: "Gamberi di Costa ai Pomodorini", germanName: "Küstengarnelen mit Kirschtomaten", spanishName: "Gambas de Costa con Tomates Cherry", polishName: "Krewetki Przybrzeżne z Pomidorkami", ukrainianName: "Прибережні креветки з чері" },
            },
            {
                id: 306,
                name: "Skampi Zgarë",
                price: 1500,
                priceUnit: "",
                imageUrl: dshSkampiZgare,
                icon: "🦐",
                menuCategoryId: 3,
                itemTranslation: { englishName: "Grilled Scampi", italianName: "Scampi alla Griglia", germanName: "Gegrillte Scampi", spanishName: "Cigalas a la Parrilla", polishName: "Skampi z Grilla", ukrainianName: "Скампі на грилі" },
            },
            {
                id: 307,
                name: "Skampi Pomodorini",
                price: 1600,
                priceUnit: "",
                imageUrl: "",
                icon: "🦐",
                menuCategoryId: 3,
                itemTranslation: { englishName: "Scampi with Cherry Tomatoes", italianName: "Scampi ai Pomodorini", germanName: "Scampi mit Kirschtomaten", spanishName: "Cigalas con Tomates Cherry", polishName: "Skampi z Pomidorkami", ukrainianName: "Скампі з чері" },
            },
            {
                id: 308,
                name: "Kallamare (Zgare/Friteze)",
                price: 650,
                priceUnit: "",
                imageUrl: dshKallamareZgare,
                icon: "🦑",
                menuCategoryId: 3,
                itemTranslation: { englishName: "Squid (Grilled/Fried)", italianName: "Calamari (Griglia/Fritti)", germanName: "Tintenfisch (Grill/Frittiert)", spanishName: "Calamares (Parrilla/Fritos)", polishName: "Kalmary (Grill/Smażone)", ukrainianName: "Кальмари (гриль/фрі)" },
            },
            {
                id: 309,
                name: "Kallamare Friteze me Vezë",
                price: 700,
                priceUnit: "",
                imageUrl: dshKallamare,
                icon: "🦑",
                menuCategoryId: 3,
                itemTranslation: { englishName: "Fried Squid with Egg", italianName: "Calamari Fritti con Uovo", germanName: "Frittierter Tintenfisch mit Ei", spanishName: "Calamares Fritos con Huevo", polishName: "Smażone Kalmary z Jajkiem", ukrainianName: "Смажені кальмари з яйцем" },
            },
            {
                id: 310,
                name: "Kallamare me Salcë",
                price: 700,
                priceUnit: "",
                imageUrl: dshKallamareSalce,
                icon: "🦑",
                menuCategoryId: 3,
                itemTranslation: { englishName: "Squid in Sauce", italianName: "Calamari in Salsa", germanName: "Tintenfisch in Sauce", spanishName: "Calamares en Salsa", polishName: "Kalmary w Sosie", ukrainianName: "Кальмари в соусі" },
            },
            {
                id: 311,
                name: "Sepie (Zgarë/Friteze)",
                price: 650,
                priceUnit: "",
                imageUrl: sepjeFriture,
                icon: "🦑",
                menuCategoryId: 3,
                itemTranslation: { englishName: "Cuttlefish (Grilled/Fried)", italianName: "Seppie (Griglia/Fritte)", germanName: "Sepia (Grill/Frittiert)", spanishName: "Sepia (Parrilla/Frita)", polishName: "Mątwa (Grill/Smażona)", ukrainianName: "Каракатиця (гриль/фрі)" },
            },
            {
                id: 312,
                name: "Sepie Friteze me Vezë",
                price: 700,
                priceUnit: "",
                imageUrl: sepjeFriture,
                icon: "🦑",
                menuCategoryId: 3,
                itemTranslation: { englishName: "Fried Cuttlefish with Egg", italianName: "Seppie Fritte con Uovo", germanName: "Frittierte Sepia mit Ei", spanishName: "Sepia Frita con Huevo", polishName: "Smażona Mątwa z Jajkiem", ukrainianName: "Смажена каракатиця з яйцем" },
            },
            {
                id: 313,
                name: "Sepie me Salcë",
                price: 700,
                priceUnit: "",
                imageUrl: "",
                icon: "🦑",
                menuCategoryId: 3,
                itemTranslation: { englishName: "Cuttlefish in Sauce", italianName: "Seppie in Salsa", germanName: "Sepia in Sauce", spanishName: "Sepia en Salsa", polishName: "Mątwa w Sosie", ukrainianName: "Каракатиця в соусі" },
            },
            {
                id: 314,
                name: "Oktapod (Zgarë/Friteze)",
                price: 900,
                priceUnit: "",
                imageUrl: dshOktapodZgare,
                icon: "🐙",
                menuCategoryId: 3,
                itemTranslation: { englishName: "Octopus (Grilled/Fried)", italianName: "Polpo (Griglia/Fritto)", germanName: "Oktopus (Grill/Frittiert)", spanishName: "Pulpo (Parrilla/Frito)", polishName: "Ośmiornica (Grill/Smażona)", ukrainianName: "Восьминіг (гриль/фрі)" },
            },
            {
                id: 315,
                name: "Arragostë / Astice / Gjinkallë",
                price: 12000,
                priceUnit: "për kg",
                imageUrl: dshArragoste,
                icon: "🦞",
                menuCategoryId: 3,
                itemTranslation: { englishName: "Spiny Lobster / Lobster / Slipper Lobster", italianName: "Aragosta / Astice / Cicala di Mare", germanName: "Languste / Hummer / Bärenkrebs", spanishName: "Langosta / Bogavante / Cigarra de Mar", polishName: "Langusta / Homar / Sprężynak", ukrainianName: "Лангуст / Омар / Морська цикада" },
            },
        ],
    },
    {
        id: 4,
        categoryName: "Peshk",
        imageUrl: imgMikseFriture,
        icon: "🐟",
        note: "Peshk i freskët nga barkat pronë e lokalit",
        menuItems: [
            {
                id: 401,
                name: "Merluc",
                price: 700,
                priceUnit: "",
                imageUrl: dshMerluc,
                icon: "🐟",
                menuCategoryId: 4,
                itemTranslation: { englishName: "Hake", italianName: "Nasello", germanName: "Seehecht", spanishName: "Merluza", polishName: "Morszczuk", ukrainianName: "Хек" },
            },
            {
                id: 402,
                name: "Barbun (Friteze/Zgare)",
                price: 800,
                priceUnit: "",
                imageUrl: dshBarbun,
                icon: "🐟",
                menuCategoryId: 4,
                itemTranslation: { englishName: "Red Mullet (Fried/Grilled)", italianName: "Triglia (Fritta/Griglia)", germanName: "Rotbarbe (Frittiert/Grill)", spanishName: "Salmonete (Frito/Parrilla)", polishName: "Barwena (Smażona/Grill)", ukrainianName: "Барабуля (фрі/гриль)" },
            },
            {
                id: 403,
                name: "Gjuzë (Friteze/Zgare)",
                price: 900,
                priceUnit: "",
                imageUrl: dshGjuze,
                icon: "🐟",
                menuCategoryId: 4,
                itemTranslation: { englishName: "Sole (Fried/Grilled)", italianName: "Sogliola (Fritta/Griglia)", germanName: "Seezunge (Frittiert/Grill)", spanishName: "Lenguado (Frito/Parrilla)", polishName: "Sola (Smażona/Grill)", ukrainianName: "Морський язик (фрі/гриль)" },
            },
            {
                id: 404,
                name: "Kocë",
                price: 700,
                priceUnit: "",
                imageUrl: dshKoce,
                icon: "🐟",
                menuCategoryId: 4,
                itemTranslation: { englishName: "Sea Bream", italianName: "Orata", germanName: "Goldbrasse", spanishName: "Dorada", polishName: "Dorada", ukrainianName: "Дорада" },
            },
            {
                id: 405,
                name: "Levrek",
                price: 700,
                priceUnit: "",
                imageUrl: dshLevrek,
                icon: "🐟",
                menuCategoryId: 4,
                itemTranslation: { englishName: "Sea Bass", italianName: "Branzino", germanName: "Wolfsbarsch", spanishName: "Lubina", polishName: "Labraks", ukrainianName: "Сібас" },
            },
            {
                id: 406,
                name: "Peskatrice",
                price: 600,
                priceUnit: "",
                imageUrl: "",
                icon: "🐟",
                menuCategoryId: 4,
                itemTranslation: { englishName: "Monkfish", italianName: "Pescatrice", germanName: "Seeteufel", spanishName: "Rape", polishName: "Żabnica", ukrainianName: "Морський чорт" },
            },
            {
                id: 407,
                name: "Mikse Friture",
                price: 700,
                priceUnit: "",
                imageUrl: dshMikseFriture,
                icon: "🍤",
                menuCategoryId: 4,
                itemTranslation: { englishName: "Mixed Fried Seafood", italianName: "Frittura Mista", germanName: "Gemischte Frittüre", spanishName: "Fritura Mixta", polishName: "Smażony Mix Owoców Morza", ukrainianName: "Мікс смажених морепродуктів" },
            },
            {
                id: 408,
                name: "Mikse Zgarë",
                price: 1400,
                priceUnit: "",
                imageUrl: imgMikseZgare,
                icon: "🔥",
                menuCategoryId: 4,
                itemTranslation: { englishName: "Mixed Grilled Seafood", italianName: "Grigliata Mista", germanName: "Gemischte Grillplatte", spanishName: "Parrillada Mixta", polishName: "Grillowany Mix Owoców Morza", ukrainianName: "Мікс морепродуктів на грилі" },
            },
            {
                id: 409,
                name: "Koce Deti",
                price: 6000,
                priceUnit: "për kg",
                imageUrl: dshKoceDeti,
                icon: "🐟",
                menuCategoryId: 4,
                itemTranslation: { englishName: "Wild Sea Bream", italianName: "Orata di Mare", germanName: "Wilde Goldbrasse", spanishName: "Dorada Salvaje", polishName: "Dzika Dorada", ukrainianName: "Дика дорада" },
            },
            {
                id: 410,
                name: "Levrek",
                price: 4000,
                priceUnit: "për kg",
                imageUrl: dshLeverkDeti,
                icon: "🐟",
                menuCategoryId: 4,
                itemTranslation: { englishName: "Sea Bass", italianName: "Branzino", germanName: "Wolfsbarsch", spanishName: "Lubina", polishName: "Labraks", ukrainianName: "Сібас" },
            },
            {
                id: 411,
                name: "Dental",
                price: 6000,
                priceUnit: "për kg",
                imageUrl: dental,
                icon: "🐟",
                menuCategoryId: 4,
                itemTranslation: { englishName: "Dentex", italianName: "Dentice", germanName: "Zahnbrasse", spanishName: "Dentón", polishName: "Kielec", ukrainianName: "Дентекс" },
            },
            {
                id: 412,
                name: "Gjuzë",
                price: 5000,
                priceUnit: "për kg",
                imageUrl: dshGjuze,
                icon: "🐟",
                menuCategoryId: 4,
                itemTranslation: { englishName: "Sole", italianName: "Sogliola", germanName: "Seezunge", spanishName: "Lenguado", polishName: "Sola", ukrainianName: "Морський язик" },
            },
            {
                id: 413,
                name: "Kovaç",
                price: 3500,
                priceUnit: "për kg",
                imageUrl: kovac,
                icon: "🐟",
                menuCategoryId: 4,
                itemTranslation: { englishName: "John Dory", italianName: "Pesce San Pietro", germanName: "Petersfisch", spanishName: "Pez de San Pedro", polishName: "Piotrosz", ukrainianName: "Сонячник" },
            },
            {
                id: 414,
                name: "Peskatrice",
                price: 2500,
                priceUnit: "për kg",
                imageUrl: peskatriceFuure,
                icon: "🐟",
                menuCategoryId: 4,
                itemTranslation: { englishName: "Monkfish", italianName: "Pescatrice", germanName: "Seeteufel", spanishName: "Rape", polishName: "Żabnica", ukrainianName: "Морський чорт" },
            },
            {
                id: 415,
                name: "Merluc I",
                price: 3000,
                priceUnit: "për kg",
                imageUrl: "",
                icon: "🐟",
                menuCategoryId: 4,
                itemTranslation: { englishName: "Hake, First Grade", italianName: "Nasello, Prima Scelta", germanName: "Seehecht, erste Wahl", spanishName: "Merluza, Primera", polishName: "Morszczuk, Pierwszy Gatunek", ukrainianName: "Хек, перший сорт" },
            },
            {
                id: 416,
                name: "Barbun I",
                price: 3000,
                priceUnit: "për kg",
                imageUrl: "",
                icon: "🐟",
                menuCategoryId: 4,
                itemTranslation: { englishName: "Red Mullet, First Grade", italianName: "Triglia, Prima Scelta", germanName: "Rotbarbe, erste Wahl", spanishName: "Salmonete, Primera", polishName: "Barwena, Pierwszy Gatunek", ukrainianName: "Барабуля, перший сорт" },
            },
        ],
    },
    {
        id: 5,
        categoryName: "Fileto",
        imageUrl: imgPeskatrice,
        icon: "🍽️",
        menuItems: [
            {
                id: 501,
                name: "Fileto Merluci Zgare",
                price: 800,
                priceUnit: "",
                imageUrl: "",
                icon: "🐟",
                menuCategoryId: 5,
                itemTranslation: { englishName: "Grilled Hake Fillet", italianName: "Filetto di Nasello alla Griglia", germanName: "Gegrilltes Seehechtfilet", spanishName: "Filete de Merluza a la Parrilla", polishName: "Filet z Morszczuka z Grilla", ukrainianName: "Філе хека на грилі" },
            },
            {
                id: 502,
                name: "Fileto Merluci Kotolet",
                price: 900,
                priceUnit: "",
                imageUrl: "",
                icon: "🐟",
                menuCategoryId: 5,
                itemTranslation: { englishName: "Breaded Hake Fillet", italianName: "Filetto di Nasello Impanato", germanName: "Paniertes Seehechtfilet", spanishName: "Filete de Merluza Empanado", polishName: "Panierowany Filet z Morszczuka", ukrainianName: "Філе хека в паніровці" },
            },
            {
                id: 503,
                name: "Fileto Gofe Zgare/Marinara",
                price: 900,
                priceUnit: "",
                imageUrl: "",
                icon: "🐟",
                menuCategoryId: 5,
                itemTranslation: { englishName: "Amberjack Fillet, Grilled or Marinara", italianName: "Filetto di Ricciola, Griglia o Marinara", germanName: "Bernsteinmakrelenfilet, Grill oder Marinara", spanishName: "Filete de Pez Limón, Parrilla o Marinara", polishName: "Filet z Serioli, Grill lub Marinara", ukrainianName: "Філе сериоли, гриль або марінара" },
            },
            {
                id: 504,
                name: "Fileto Shpate Zgare/Marinara",
                price: 1000,
                priceUnit: "",
                imageUrl: "",
                icon: "🗡️",
                menuCategoryId: 5,
                itemTranslation: { englishName: "Swordfish Fillet, Grilled or Marinara", italianName: "Filetto di Pesce Spada, Griglia o Marinara", germanName: "Schwertfischfilet, Grill oder Marinara", spanishName: "Filete de Pez Espada, Parrilla o Marinara", polishName: "Filet z Miecznika, Grill lub Marinara", ukrainianName: "Філе меч-риби, гриль або марінара" },
            },
            {
                id: 505,
                name: "Fileto Kerri Zgare/Marinara",
                price: 1300,
                priceUnit: "",
                imageUrl: "",
                icon: "🐟",
                menuCategoryId: 5,
                itemTranslation: {},
            },
            {
                id: 506,
                name: "Fileto Levreku Zgare/Marinara",
                price: 1300,
                priceUnit: "",
                imageUrl: "",
                icon: "🐟",
                menuCategoryId: 5,
                itemTranslation: { englishName: "Sea Bass Fillet, Grilled or Marinara", italianName: "Filetto di Branzino, Griglia o Marinara", germanName: "Wolfsbarschfilet, Grill oder Marinara", spanishName: "Filete de Lubina, Parrilla o Marinara", polishName: "Filet z Labraksa, Grill lub Marinara", ukrainianName: "Філе сібаса, гриль або марінара" },
            },
            {
                id: 507,
                name: "Fileto Dentali Zgare/Marinara",
                price: 1500,
                priceUnit: "",
                imageUrl: "",
                icon: "🐟",
                menuCategoryId: 5,
                itemTranslation: { englishName: "Dentex Fillet, Grilled or Marinara", italianName: "Filetto di Dentice, Griglia o Marinara", germanName: "Zahnbrassenfilet, Grill oder Marinara", spanishName: "Filete de Dentón, Parrilla o Marinara", polishName: "Filet z Kielca, Grill lub Marinara", ukrainianName: "Філе дентекса, гриль або марінара" },
            },
            {
                id: 508,
                name: "Fileto Toni Zgare",
                price: 900,
                priceUnit: "",
                imageUrl: dshTunaSteak,
                icon: "🐟",
                menuCategoryId: 5,
                itemTranslation: { englishName: "Grilled Tuna Fillet", italianName: "Filetto di Tonno alla Griglia", germanName: "Gegrilltes Thunfischfilet", spanishName: "Filete de Atún a la Parrilla", polishName: "Filet z Tuńczyka z Grilla", ukrainianName: "Філе тунця на грилі" },
            },
        ],
    },
    {
        id: 6,
        categoryName: "Tava Balte",
        imageUrl: imgTavaTryeza,
        icon: "🍲",
        menuItems: [
            {
                id: 601,
                name: "Tavë Karkaleci me Pana",
                price: 700,
                priceUnit: "",
                imageUrl: dshTaveKarkaleci,
                icon: "🍲",
                menuCategoryId: 6,
                itemTranslation: { englishName: "Prawn Casserole with Cream", italianName: "Tegamino di Gamberi alla Panna", germanName: "Garnelenauflauf mit Sahne", spanishName: "Cazuela de Gambas con Nata", polishName: "Zapiekanka z Krewetek ze Śmietaną", ukrainianName: "Запіканка з креветок у вершках" },
            },
            {
                id: 602,
                name: "Tavë Fruta Deti Pikante",
                price: 650,
                priceUnit: "",
                imageUrl: dshTaveDetiPikante,
                icon: "🌶️",
                menuCategoryId: 6,
                itemTranslation: { englishName: "Spicy Seafood Casserole", italianName: "Tegamino di Frutti di Mare Piccante", germanName: "Pikanter Meeresfrüchteauflauf", spanishName: "Cazuela Picante de Mariscos", polishName: "Pikantna Zapiekanka z Owoców Morza", ukrainianName: "Гостра запіканка з морепродуктів" },
            },
            {
                id: 603,
                name: "Tavë Oktapodi Pikant",
                description: "Specialiteti i lokalit",
                price: 2000,
                priceUnit: "2 pers.",
                imageUrl: dshTaveOktapodiPikant,
                icon: "🐙",
                menuCategoryId: 6,
                itemTranslation: { englishName: "Spicy Octopus Casserole", italianName: "Tegamino di Polpo Piccante", germanName: "Pikanter Oktopusauflauf", spanishName: "Cazuela Picante de Pulpo", polishName: "Pikantna Zapiekanka z Ośmiornicy", ukrainianName: "Гостра запіканка з восьминога" },
            },
            {
                id: 604,
                name: "Tavë Merluci Tradicionale",
                price: 1600,
                priceUnit: "2 pers.",
                imageUrl: "",
                icon: "🍲",
                menuCategoryId: 6,
                itemTranslation: { englishName: "Traditional Hake Casserole", italianName: "Tegamino di Nasello Tradizionale", germanName: "Traditioneller Seehechtauflauf", spanishName: "Cazuela Tradicional de Merluza", polishName: "Tradycyjna Zapiekanka z Morszczuka", ukrainianName: "Традиційна запіканка з хека" },
            },
            {
                id: 605,
                name: "Tavë Peskatrice Tradicionale",
                price: 2500,
                priceUnit: "për kg",
                imageUrl: peskatriceFuure,
                icon: "🍲",
                menuCategoryId: 6,
                itemTranslation: { englishName: "Traditional Monkfish Casserole", italianName: "Tegamino di Pescatrice Tradizionale", germanName: "Traditioneller Seeteufelauflauf", spanishName: "Cazuela Tradicional de Rape", polishName: "Tradycyjna Zapiekanka z Żabnicy", ukrainianName: "Традиційна запіканка з морського чорта" },
            },
            {
                id: 606,
                name: "Tavë Gjuzë e Bardhë",
                description: "Specialiteti i lokalit",
                price: 5000,
                priceUnit: "për kg",
                imageUrl: "",
                icon: "🍲",
                menuCategoryId: 6,
                itemTranslation: { englishName: "White Sole Casserole", italianName: "Tegamino di Sogliola Bianca", germanName: "Auflauf von weißer Seezunge", spanishName: "Cazuela de Lenguado Blanco", polishName: "Zapiekanka z Białej Soli", ukrainianName: "Запіканка з білого морського язика" },
            },
            {
                id: 607,
                name: "Tavë Levreku Furre",
                price: 4500,
                priceUnit: "për kg",
                imageUrl: dshLeverkFurre,
                icon: "🍲",
                menuCategoryId: 6,
                itemTranslation: { englishName: "Baked Sea Bass Casserole", italianName: "Branzino al Forno in Tegame", germanName: "Wolfsbarsch aus dem Ofen", spanishName: "Lubina al Horno", polishName: "Labraks Zapiekany", ukrainianName: "Запечений сібас" },
            },
            {
                id: 608,
                name: "Tavë Dentali Furre",
                price: 6500,
                priceUnit: "për kg",
                imageUrl: dentalFurre,
                icon: "🍲",
                menuCategoryId: 6,
                itemTranslation: { englishName: "Baked Dentex Casserole", italianName: "Dentice al Forno in Tegame", germanName: "Zahnbrasse aus dem Ofen", spanishName: "Dentón al Horno", polishName: "Kielec Zapiekany", ukrainianName: "Запечений дентекс" },
            },
            {
                id: 609,
                name: "Tavë Orizi me Kokë Peshku",
                description: "Specialiteti i lokalit",
                price: 5000,
                priceUnit: "5 pers.",
                imageUrl: "",
                icon: "🍚",
                menuCategoryId: 6,
                itemTranslation: { englishName: "Rice Casserole with Fish Head", italianName: "Tegamino di Riso con Testa di Pesce", germanName: "Reisauflauf mit Fischkopf", spanishName: "Cazuela de Arroz con Cabeza de Pescado", polishName: "Zapiekanka Ryżowa z Głową Ryby", ukrainianName: "Рисова запіканка з рибною головою" },
            },
        ],
    },
    {
        id: 7,
        categoryName: "Verë e Bardhë",
        // A bottle is not a plate: the header counts these apart. Same flag the server sends.
        categoryType: "BEVERAGE",
        imageUrl: "",
        icon: "🥂",
        menuItems: [
            { id: 701, name: "Verë e Hapur (ALB)", price: 800, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🥂", menuCategoryId: 7, itemTranslation: { englishName: "House White Wine (ALB)", italianName: "Vino Bianco della Casa (ALB)", germanName: "Offener Weißwein (ALB)", spanishName: "Vino Blanco de la Casa (ALB)", polishName: "Wino Białe Domowe (ALB)", ukrainianName: "Домашнє біле вино (ALB)" } },
            { id: 702, name: "Shesh i Bardhë (Kokomani ALB)", price: 1600, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🥂", menuCategoryId: 7, itemTranslation: {} },
            { id: 703, name: "Chardonnay", price: 1600, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🥂", menuCategoryId: 7, itemTranslation: {} },
            { id: 704, name: "Pinot Grigio", price: 1800, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🥂", menuCategoryId: 7, itemTranslation: {} },
            { id: 705, name: "Gewurztraminer", price: 2000, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🥂", menuCategoryId: 7, itemTranslation: {} },
            { id: 706, name: "Prosecco", price: 2000, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🍾", menuCategoryId: 7, itemTranslation: {} },
            { id: 707, name: "Greco di Tufo", price: 2700, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🥂", menuCategoryId: 7, itemTranslation: {} },
            { id: 708, name: "Sauvignon Livon", price: 2800, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🥂", menuCategoryId: 7, itemTranslation: {} },
            { id: 709, name: "Pecorino", price: 3000, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🥂", menuCategoryId: 7, itemTranslation: {} },
            { id: 710, name: "Riesling Hugel", price: 4000, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🥂", menuCategoryId: 7, itemTranslation: {} },
            { id: 711, name: "Donnaluce", price: 5000, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🥂", menuCategoryId: 7, itemTranslation: {} },
            { id: 712, name: "Franciacorta", price: 6000, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🍾", menuCategoryId: 7, itemTranslation: {} },
            { id: 713, name: "Braidealte Livon", price: 7000, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🥂", menuCategoryId: 7, itemTranslation: {} },
            { id: 714, name: "Sheshi Bardhë 0.375", price: 800, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🥂", menuCategoryId: 7, itemTranslation: {} },
            { id: 715, name: "Sauvignon Trapiche 0.375", price: 900, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🥂", menuCategoryId: 7, itemTranslation: {} },
            { id: 716, name: "Pinot Grigio 0.375", price: 1000, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🥂", menuCategoryId: 7, itemTranslation: {} },
            { id: 717, name: "Sauvignon Livon 0.375", price: 1400, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🥂", menuCategoryId: 7, itemTranslation: {} },
            { id: 718, name: "Lugano Ca Maiol 0.375", price: 1500, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🥂", menuCategoryId: 7, itemTranslation: {} },
            { id: 719, name: "Riesling Hugel 0.375", price: 2000, priceUnit: "", imageUrl: stWhiteWine, isReferenceImage: true, icon: "🥂", menuCategoryId: 7, itemTranslation: {} },
        ],
    },
    {
        id: 8,
        categoryName: "Verë e Kuqe",
        // A bottle is not a plate: the header counts these apart. Same flag the server sends.
        categoryType: "BEVERAGE",
        imageUrl: "",
        icon: "🍷",
        menuItems: [
            { id: 801, name: "Verë e Hapur (ALB)", price: 800, priceUnit: "", imageUrl: stRedWine, isReferenceImage: true, icon: "🍷", menuCategoryId: 8, itemTranslation: { englishName: "House Red Wine (ALB)", italianName: "Vino Rosso della Casa (ALB)", germanName: "Offener Rotwein (ALB)", spanishName: "Vino Tinto de la Casa (ALB)", polishName: "Wino Czerwone Domowe (ALB)", ukrainianName: "Домашнє червоне вино (ALB)" } },
            { id: 802, name: "Cabernet Sauvignon", price: 1800, priceUnit: "", imageUrl: stRedWine, isReferenceImage: true, icon: "🍷", menuCategoryId: 8, itemTranslation: {} },
            { id: 803, name: "Sheshi i Zi (Kokomani ALB)", price: 2400, priceUnit: "", imageUrl: stRedWine, isReferenceImage: true, icon: "🍷", menuCategoryId: 8, itemTranslation: {} },
            { id: 804, name: "Negro Amaro", price: 2400, priceUnit: "", imageUrl: stRedWine, isReferenceImage: true, icon: "🍷", menuCategoryId: 8, itemTranslation: {} },
            { id: 805, name: "Primitivo Di Manduria", price: 2800, priceUnit: "", imageUrl: stRedWine, isReferenceImage: true, icon: "🍷", menuCategoryId: 8, itemTranslation: {} },
            { id: 806, name: "Montepulciano", price: 2800, priceUnit: "", imageUrl: stRedWine, isReferenceImage: true, icon: "🍷", menuCategoryId: 8, itemTranslation: {} },
            { id: 807, name: "Goce Primitivo", price: 4500, priceUnit: "", imageUrl: stRedWine, isReferenceImage: true, icon: "🍷", menuCategoryId: 8, itemTranslation: {} },
            { id: 808, name: "Papale Primitivo", price: 5000, priceUnit: "", imageUrl: stRedWine, isReferenceImage: true, icon: "🍷", menuCategoryId: 8, itemTranslation: {} },
            { id: 809, name: "Primitivo 60", price: 6000, priceUnit: "", imageUrl: stRedWine, isReferenceImage: true, icon: "🍷", menuCategoryId: 8, itemTranslation: {} },
            { id: 810, name: "Amarone", price: 7000, priceUnit: "", imageUrl: stRedWine, isReferenceImage: true, icon: "🍷", menuCategoryId: 8, itemTranslation: {} },
            { id: 811, name: "Brunello", price: 8000, priceUnit: "", imageUrl: stRedWine, isReferenceImage: true, icon: "🍷", menuCategoryId: 8, itemTranslation: {} },
            { id: 812, name: "Trapiche 0.375", price: 1000, priceUnit: "", imageUrl: stRedWine, isReferenceImage: true, icon: "🍷", menuCategoryId: 8, itemTranslation: {} },
            { id: 813, name: "Sheshi i Zi 0.375", price: 1200, priceUnit: "", imageUrl: stRedWine, isReferenceImage: true, icon: "🍷", menuCategoryId: 8, itemTranslation: {} },
            { id: 814, name: "Goce Primitivo 0.375", price: 2400, priceUnit: "", imageUrl: stRedWine, isReferenceImage: true, icon: "🍷", menuCategoryId: 8, itemTranslation: {} },
            { id: 815, name: "Brunello di Montepulciano 0.375", price: 4000, priceUnit: "", imageUrl: stRedWine, isReferenceImage: true, icon: "🍷", menuCategoryId: 8, itemTranslation: {} },
        ],
    },
];

export default menu;
